import React from "react";
import { PencilIcon } from "@heroicons/react/24/outline";

const EditOverlay: React.FC = () => (
  <div className="absolute inset-0 z-20 rounded-md flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-200 backdrop-blur-sm bg-black/50">
    <div className="flex flex-row items-center gap-2 text-highlight">
      <PencilIcon className="h-4 w-4" />
      <span className="text-sm font-medium">Edit</span>
    </div>
  </div>
);

export default EditOverlay;
